/**
 * Env
 */
export class Env {
  /**
   * シングルサインオンでログインするか判定
   *
   * @returns {bool} true:シングルサインオンでログインする
   */
  static isSingleSignOn() {
    return process.env.VUE_APP_IS_SINGLE_SIGN_ON === 'true'
  }
}
